import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './@theme/components/Services/auth.guard';
import { MapViewComponentComponent } from './login/map-view-component/map-view-component.component';
import { NewMapViewComponent } from './login/new-map-view/new-map-view.component';

export const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'mapview', component: MapViewComponentComponent},
  {path: 'newmapview', component: NewMapViewComponent},


  {path: 'web', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
      canLoad: [AuthGuard],
  },

  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
